module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/bfb27fed13988d2cfed83e3592cd9877.png";